import React from "react";
import { useTranslation } from "react-i18next";
import MetricCard from "../components/MetricCard";
import InfoBox from "../components/InfoBox";
import StatisticCard from "../components/StatisticCard";
import HeatMap from "../components/HeatMap";
import ProUpgradeCard from "../components/ProUpgradeCard";
import {
  TrendUpIcon,
  BarChartIcon,
  StarIcon,
} from "../components/StatisticsIcons";

/**
 * Basic Statistics Tab Komponente
 * Zeigt grundlegende Statistiken für alle Benutzer an
 */
const BasicStatisticsTab = ({
  basicStatistics,
  showInfoBox,
  onDismissInfoBox,
  isProMember,
}) => {
  const { t } = useTranslation();

  const { threeDartAverage, totalScore, highestRound } = basicStatistics;

  return (
    <div className="max-w-4xl mx-auto">
      {/* Info Box */}
      <InfoBox
        title={t("statistics.basicStats.infobox_title")}
        message={t("statistics.basicStats.infobox_text")}
        show={showInfoBox}
        onDismiss={onDismissInfoBox}
        color="yellow"
      />

      {/* Key Metrics Section */}
      <div className="grid grid-cols-3 gap-3 sm:gap-6 lg:gap-8 mb-6">
        <MetricCard
          icon={<TrendUpIcon />}
          title={t("statistics.basicStats.scoringAverage")}
          value={parseFloat(threeDartAverage).toFixed(2)}
          hint={t("statistics.basicStats.scoringAverageHint")}
          className="min-h-[120px] sm:min-h-[140px]"
        />

        <MetricCard
          icon={<BarChartIcon />}
          title={t("statistics.basicStats.totalScore")}
          value={totalScore}
          hint={t("statistics.basicStats.totalScoreHint")}
          className="min-h-[120px] sm:min-h-[140px]"
        />

        <MetricCard
          icon={<StarIcon />}
          title={t("statistics.basicStats.highestScore")}
          value={highestRound}
          hint={t("statistics.basicStats.highestScoreHint")}
          className="min-h-[120px] sm:min-h-[140px]"
        />
      </div>

      {/* Heat Map Section */}
      <StatisticCard
        title={t("statistics.basicStats.throwingPatternAnalysis")}
        hint={t("statistics.basicStats.heatMapDescription")}
      >
        <div className="bg-secondary/30 rounded-lg p-6">
          <div className="grid md:grid-cols-2 gap-6">
            <div className="relative">
              <HeatMap />
            </div>
            <div className="flex flex-col justify-center m-4">
              <p className="text-white text-sm m-2">
                {t("statistics.basicStats.heatMapDescription")}
              </p>
              <ul className="text-gray-300 text-sm list-disc list-inside">
                <li>{t("statistics.basicStats.heatTip1")}</li>
                <li>{t("statistics.basicStats.heatTip2")}</li>
              </ul>
            </div>
          </div>
        </div>
      </StatisticCard>

      {/* Pro Upgrade Card für Free Users */}
      {!isProMember && <ProUpgradeCard />}
    </div>
  );
};

export default BasicStatisticsTab;
